import ImageWithFallback from "@/components/ImageWithFallback";
import { PRODUCT_GROUPS } from "@/constant/constants";
import StatusBadge from "@/components/StatusBadge";
import {
  baseProductStatusBgColors,
  baseProductStatusLabels,
} from "@/constant/BaseProduct/status";

export const columns = (productGroup = PRODUCT_GROUPS.JERSEYS) => {
  const baseProductLabelMap = baseProductStatusLabels;
  const baseProductBgColorMap = baseProductStatusBgColors;

  const jerseyColumns = [
    {
      accessorKey: "status",
      header: `MPL Status`,
      cell: ({ row }) =>
        row.original.deleted_at != null ? (
          <StatusBadge
            status="deleted"
            statusLabelMap={baseProductLabelMap}
            statusBgColorMap={baseProductBgColorMap}
          />
        ) : (
          <StatusBadge status={row.getValue("status")} />
        ),
    },
    {
      accessorKey: "image_url",
      header: "Image",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("image_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
    {
      id: "base_product_code",
      accessorKey: "base_product_code",
      header: "Base Product ID",
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: "Base Product Name",
      enableSorting: false,
    },
    {
      accessorKey: "slug_en_uk",
      header: "Base Product Slug (EN-UK)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_en_us",
      header: "Base Product Slug (EN-US)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_de",
      header: "Base Product Slug (DE)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_fr",
      header: "Base Product Slug (FR)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_it",
      header: "Base Product Slug (IT)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_pt",
      header: "Base Product Slug (PT)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_pl",
      header: "Base Product Slug (PL)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_nl",
      header: "Base Product Slug (NL)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_el",
      header: "Base Product Slug (EL)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_tr",
      header: "Base Product Slug (TR)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_sv",
      header: "Base Product Slug (SV)",
      enableSorting: false,
    },
    {
      accessorKey: "slug_ro",
      header: "Base Product Slug (RO)",
      enableSorting: false,
    },
    {
      id: "sport.code",
      accessorFn: (row) => row.sport && `${row.sport.code}`,
      header: "Sport ID",
      enableSorting: false,
    },
    {
      id: "product.code",
      accessorFn: (row) => row.product && `${row.product.code}`,
      header: "Product ID",
      enableSorting: false,
    },
    {
      id: "team.code",
      accessorFn: (row) => row.team && `${row.team.code}`,
      header: "Team ID",
      enableSorting: false,
    },
    {
      id: "term.code",
      accessorFn: (row) => row.term && `${row.term.code}`,
      header: "Term ID",
      enableSorting: false,
    },
    {
      id: "edition.code",
      accessorFn: (row) => row.edition && `${row.edition.code}`,
      header: "Edition ID",
      enableSorting: false,
    },
  ];

  const teamMerchandiseColumns = [
    {
      id: "base_product_code",
      accessorKey: "base_product_code",
      header: "Base Product ID",
    },
    {
      id: "sport.code",
      accessorFn: (row) => row.sport && `${row.sport.code} - ${row.sport.name}`,
      header: "Sport",
    },
    {
      id: "product.code",
      accessorFn: (row) =>
        row.product && `${row.product.code} - ${row.product.name}`,
      header: "Product",
    },
    {
      id: "team.code",
      accessorFn: (row) => row.team && `${row.team.code} - ${row.team.name}`,
      header: "Team",
    },
  ];

  const matchBallColumns = [
    {
      id: "base_product_code",
      accessorKey: "base_product_code",
      header: "Base Product ID",
    },
    {
      id: "sport.code",
      accessorFn: (row) => row.sport && `${row.sport.code} - ${row.sport.name}`,
      header: "Sport",
    },
    {
      id: "product.code",
      accessorFn: (row) =>
        row.product && `${row.product.code} - ${row.product.name}`,
      header: "Product",
    },
    {
      id: "competition.code",
      accessorFn: (row) =>
        row.competition && `${row.competition.code} - ${row.competition.name}`,
      header: "Competition",
    },
    {
      id: "term.code",
      accessorFn: (row) => row.term && `${row.term.code} - ${row.term.name}`,
      header: "Term",
    },
    {
      id: "edition.code",
      accessorFn: (row) =>
        row.edition && `${row.edition.code} - ${row.edition.name}`,
      header: "Edition",
    },
  ];

  const columns = {
    [PRODUCT_GROUPS.JERSEYS]: jerseyColumns,
    [PRODUCT_GROUPS.TEAM_MERCHANDISE]: teamMerchandiseColumns,
    [PRODUCT_GROUPS.MATCH_BALLS]: matchBallColumns,
  };

  return columns[productGroup] || columns[PRODUCT_GROUPS.JERSEYS];
};
